export default "__VITE_ASSET__DgaE2dXb__"